import PopupEditPaid from './PopupEditPaid';

export default PopupEditPaid;
